import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { DatePicker } from "react-advance-jalaali-datepicker";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import messagesDiscountBanner from "../../../../messages/discount/banner";

export default function EditDiscountToPositionBanner() {
  const [amount, setAmount] = useState(0);
  const [positionPrice, setPositionPrice] = useState(0);
  const [position, setPosition] = useState();
  const [previewPrice, setPreviewPrice] = useState(0);
  const history = useHistory();
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const params = useParams();
  const discountID = params.id;
  const positionTagHtmlID = params.positionTagHtmlID;

  useEffect(() => {
    getPosotitonData(positionTagHtmlID);
  }, []);

  useEffect(() => {
    if (!position) {
      return;
    }

    setPositionPrice(position.pos_price);
  }, [position]);

  useEffect(() => {
    if (!positionPrice) {
      return;
    }
    changePreviewPrice();
  }, [amount]);

  useEffect(() => {
    if (!position) {
      return;
    }
    if (!positionPrice) {
      return;
    }
    getDiscount(discountID);
  }, [positionPrice]);

  const changePreviewPrice = () => {
    flushMessage();
    let previewPrice = positionPrice * ((100 - amount) / 100);
    if (previewPrice < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messagesDiscountBanner.AMOUNT_DISCOUNT_POSITION_BANNER_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    setPreviewPrice(previewPrice);
  };

  const flushMessage = () => {
    setMessage({});
  };

  const getDiscount = async (discountID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const discount = await sendRequestGetDiscount(discountID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    setAmount(discount.amount);
    document.querySelector("#description").value = discount.description;
    document.querySelector("#start-date").innerHTML =
      helpersNumbers.toPersianNum(discount.start_date.replace("_", " "));
    document.querySelector("#end-date").innerHTML = helpersNumbers.toPersianNum(
      discount.end_date.replace("_", " ")
    );
  };

  const sendRequestGetDiscount = async (discountID) => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner/" +
          discountID,
        headersRequest
      );
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getPosotitonData = async (positionTagHtmlID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const positionData = await sendRequestGetPosotitonData(positionTagHtmlID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!positionData) {
      return false;
    }
    setPosition(positionData);
  };

  const sendRequestGetPosotitonData = async (positionTagHtmlID) => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/report/" +
          positionTagHtmlID,
        headersRequest
      );
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddDiscountPositionBanner =
      await sendRequestEditDiscountPositionBanner(discountID, dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddDiscountPositionBanner) {
      goScrollIntoTag("container-add-discount-banner-position");
      return;
    }
    history.push(`/manage/discount/select-position-banner`);
    return;
  };

  const sendRequestEditDiscountPositionBanner = async (
    discountID,
    dataForm
  ) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/position-banner/" +
          discountID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
  };

  const getDataForm = () => {
    return {
      amount: amount + "",
      description: document.querySelector("#description").value,
    };
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن تخفیف به جایگاه بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div
              className="card-body"
              id="container-add-discount-banner-position"
            >
              <div className="d-flex flex-row-reverse justify-content-between">
                <div className="text-left">
                  <Link
                    to="/manage/discount/select-position-banner"
                    className="btn btn-primary"
                  >
                    <span>بازگشت</span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
                <div>
                  {messageTag}
                  <form onSubmit={sendForm}>
                    <div className="d-flex align-items-center">
                      <span>
                        مبلغ جایگاه
                        <span className="btn btn-secondary">
                          {positionTagHtmlID}
                        </span>
                      </span>
                      <span className="px-2">:</span>
                      <span className="pl-2 number-finance">
                        {positionPrice &&
                          helpersNumbers.toPersianNum(
                            helpersNumbers.addCommaToSeparateGroupThreeNumber(
                              positionPrice
                            )
                          )}{" "}
                      </span>
                      <span>تومان</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span>مبلغ تخفیف خورده جایگاه</span>
                      <span className="px-2">:</span>
                      <span className="pl-2 number-finance">
                        {positionPrice &&
                          helpersNumbers.toPersianNum(
                            helpersNumbers.addCommaToSeparateGroupThreeNumber(
                              previewPrice
                            )
                          )}{" "}
                      </span>
                      <span>تومان</span>
                    </div>
                    <div className="form-group py-2">
                      <div className="d-flex align-items-center">
                        <span className="pl-2">
                          <label className="m-0">مقدار تخفیف</label>
                        </span>
                      </div>
                      <div>
                        <div className="input-group">
                          <input
                            type="number"
                            min="1"
                            max="99"
                            id="amount"
                            className="form-control number-finance"
                            dir="ltr"
                            value={amount}
                            onChange={(e) => {
                              setAmount(parseInt(e.target.value));
                            }}
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">٪</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="py-2">
                        <span>تاریخ شروع</span>
                        <span className="px-2">:</span>
                        <span
                          dir="ltr"
                          id="start-date"
                          className="number-finance"
                        ></span>
                      </div>
                      <div className="py-3">
                        <span>تاریخ پایان </span>
                        <span className="px-2">:</span>
                        <span
                          dir="ltr"
                          id="end-date"
                          className="number-finance"
                        ></span>
                      </div>
                    </div>
                    <div className="pt-3">
                      <div>
                        <label className="py-2 m-0">توضیحات</label>
                      </div>
                      <div>
                        <textarea
                          id="description"
                          className="form-control"
                          rows="5"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="pt-3">
                      <button className="btn btn-success">ویرایش</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
